var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button ms-btn has-tooltip-right",class:{
		'is-loading ms-btn-danger': _vm.isDeletingRequirements,
	},attrs:{"id":"delete-selected-items-requirements-button","disabled":!_vm.$canEditWorklist() || !_vm.isBulkEditing || !_vm.canDeleteRequirements},on:{"click":_vm.onBulkDeleteRequirements}},[_c('fa-icon',{staticClass:"delete-requirements-icon",attrs:{"icon":"trash-alt","size":"lg"}}),_vm._v("Delete Requirements From Selected ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }